import ContextualInfo from './ContextualInfo';

export default ContextualInfo;
